import style from "./style";
const PreLoader = () => (
  <div class={style.loadingOverlay}>
    <span></span>
  </div>
);
export default PreLoader;



// WEBPACK FOOTER //
// ./components/preLoader/index.js